import charcoal1 from '../assets/images/Charcoal/charcoal1.webp';
import charcoal2 from '../assets/images/Charcoal/charcoal2.webp';
import rose1 from '../assets/images/Rose/Rose1.webp';
import rose2 from '../assets/images/Rose/Rose2.webp';
import mint1 from '../assets/images/Mint/Mint1.webp';
import mint2 from '../assets/images/Mint/Mint2.webp';
import neem1 from '../assets/images/Neem/Neem1.webp';
import neem2 from '../assets/images/Neem/Neem2.webp';
import neem3 from '../assets/images/Neem/Neem3.webp';
import papaya1 from '../assets/images/Papaya/Papaya1.webp';
import papaya2 from '../assets/images/Papaya/Papaya2.webp';
import MilkAloe1 from '../assets/images/Milk&AloeVera_Soap/MilkAloe1.webp';
import MilkAloe2 from '../assets/images/Milk&AloeVera_Soap/MilkAloe2.webp';
import lemon1 from '../assets/images/Lemon_Soap/Lemon1.webp';
import lemon2 from '../assets/images/Lemon_Soap/Lemon2.webp';
import honey1 from '../assets/images/HoneyGlycerine_Soap/Honey1.webp';
import honey2 from '../assets/images/HoneyGlycerine_Soap/Honey2.webp';
import coffee1 from '../assets/images/Coffee_Soap/Coffee1.webp';
import coffee2 from '../assets/images/Coffee_Soap/Coffee2.webp';
import rice1 from '../assets/images/Rice_Soap/Rice1.webp';
import rice2 from '../assets/images/Rice_Soap/Rice2.webp';

const products = [
  {
    id: 1,
    name: 'Charcoal Soap',
    price: 199,
    shortDescription: 'Deep-cleansing activated charcoal that draws out impurities for visibly clearer skin.',
    description: 'Powered by activated charcoal, this handcrafted bar acts like a magnet — pulling out dirt, excess oil, and toxins from deep within your pores. Blended with pure essential oils, it purifies without stripping, leaving your skin balanced, smooth, and refreshed. 100% free from parabens, sulphates, and harsh chemicals.',
    shelfLife: '6 months from manufacture date',
    weight: '100g (approx)',
    dimensions: '8cm x 5.4cm x 2.3cm',
    images: [charcoal1, charcoal2],
  },
  {
    id: 2,
    name: 'Rose Soap',
    price: 199,
    shortDescription: 'Delicate rose petal extract that softens, brightens, and leaves skin subtly fragrant.',
    description: 'Crafted with real rose petal extract, this luxurious bar wraps your skin in the timeless scent of fresh blooms while delivering deep, lasting moisture. Rose\'s natural astringent properties help even skin tone and reduce redness, making every wash feel like a spa ritual. Gentle enough for daily use, free from parabens and harsh chemicals.',
    shelfLife: '6 months from manufacture date',
    weight: '100g (approx)',
    dimensions: '8cm x 5.4cm x 2.3cm',
    images: [rose1, rose2],
  },
  {
    id: 3,
    name: 'Mint Soap',
    price: 199,
    shortDescription: 'Invigorating mint that cools, refreshes, and wakes up your skin instantly.',
    description: 'Start your day with a burst of cool clarity. This handcrafted mint soap uses natural peppermint extract to deliver an instant cooling sensation that soothes irritated skin and leaves you feeling energised from head to toe. Its natural antiseptic properties keep skin fresh and clean throughout the day. Free from parabens and harsh chemicals.',
    shelfLife: '6 months from manufacture date',
    weight: '100g (approx)',
    dimensions: '8cm x 5.4cm x 2.3cm',
    images: [mint1, mint2],
  },
  {
    id: 4,
    name: 'Neem Soap',
    price: 149,
    shortDescription: 'Ancient neem goodness that fights bacteria, soothes breakouts, and heals skin naturally.',
    description: 'Rooted in centuries of Ayurvedic tradition, our Neem Soap harnesses the powerful antibacterial and antifungal properties of pure neem extract. It gently targets acne, blemishes, and skin irritations while keeping your complexion nourished and balanced. A daily essential for anyone dealing with oily, acne-prone, or sensitive skin. Free from parabens and harsh chemicals.',
    shelfLife: '6 months from manufacture date',
    weight: '100g (approx)',
    dimensions: '8cm x 5.4cm x 2.3cm',
    images: [neem1, neem2, neem3],
  },
  {
    id: 5,
    name: 'Papaya Soap',
    price: 199,
    shortDescription: 'Natural papain enzymes gently exfoliate dull skin to reveal a brighter, smoother glow.',
    description: 'Packed with natural papain enzymes, this handcrafted bar gently dissolves dead skin cells to reveal the fresh, luminous skin underneath. Papaya\'s rich vitamin C content helps fade dark spots and uneven tone over time, giving you a naturally radiant complexion. Silky, smooth lather that never feels harsh. Free from parabens and harsh chemicals.',
    shelfLife: '6 months from manufacture date',
    weight: '100g (approx)',
    dimensions: '8cm x 5.4cm x 2.3cm',
    images: [papaya1, papaya2],
  },
  {
    id: 6,
    name: 'Milk & Aloe Vera Soap',
    price: 199,
    shortDescription: 'Creamy goat milk meets soothing aloe vera for intensely soft, hydrated skin.',
    description: 'A deeply comforting blend of goat milk and aloe vera, this gentle bar cleanses and replenishes moisture in one step. Goat milk\'s natural lactic acid softly exfoliates while aloe vera calms and hydrates, making this perfect for dry, sensitive, or irritation-prone skin. Rich, creamy lather that leaves skin feeling velvety smooth. Free from parabens and harsh chemicals.',
    shelfLife: '6 months from manufacture date',
    weight: '100g (approx)',
    dimensions: '8cm x 5.4cm x 2.3cm',
    images: [MilkAloe1, MilkAloe2],
  },
  {
    id: 7,
    name: 'Lemon Soap',
    price: 149,
    shortDescription: 'Zesty lemon extract brightens dull skin and leaves you smelling fresh all day.',
    description: 'Sunshine in a bar. Our Lemon Soap combines the brightening power of lemon extract with the calming hydration of aloe vera for a cleanse that truly revitalises. Vitamin C-rich lemon helps reduce dark spots, tighten pores, and restore your skin\'s natural radiance — while the fresh citrus scent lifts your mood with every wash. Free from parabens and harsh chemicals.',
    shelfLife: '6 months from manufacture date',
    weight: '100g (approx)',
    dimensions: '8cm x 5.4cm x 2.3cm',
    images: [lemon1, lemon2],
  },
  {
    id: 8,
    name: 'Honey & Glycerine Soap',
    price: 149,
    shortDescription: 'Real honey and glycerine lock in moisture for irresistibly soft, nourished skin.',
    description: 'Nature\'s best humectants, together at last. Raw honey draws moisture into the skin while glycerine seals it in, creating an ultra-hydrating bar that leaves your skin feeling supple and smooth long after rinsing. Its natural antibacterial properties make it ideal for sensitive or blemish-prone skin. Gentle enough for the whole family. Free from parabens and harsh chemicals.',
    shelfLife: '6 months from manufacture date',
    weight: '100g (approx)',
    dimensions: '8cm x 5.4cm x 2.3cm',
    images: [honey1, honey2],
  },
  {
    id: 9,
    name: 'Coffee Soap',
    price: 199,
    shortDescription: 'Energising coffee grounds exfoliate and de-puff skin for a firm, glowing finish.',
    description: 'Wake up your skin the way you wake up your mornings. Our Coffee Soap combines finely ground coffee — a natural exfoliant and circulation booster — with the creamy richness of goat milk. The gentle scrubbing action buffs away dead cells, reduces the appearance of cellulite, and leaves skin visibly firmer and more radiant. The rich, warm coffee aroma makes every shower a ritual. Free from parabens and harsh chemicals.',
    shelfLife: '6 months from manufacture date',
    weight: '100g (approx)',
    dimensions: '8cm x 5.4cm x 2.3cm',
    images: [coffee1, coffee2],
  },
    {
    id: 10,
    name: 'Rice Soap',
    price: 199,
    shortDescription: 'Rice water and goat milk combined to brighten, nourish, and leave skin silky smooth.',
    description: 'Enriched with the age-old beauty secret of rice water, this handcrafted bar harnesses the natural brightening and skin-softening properties of rice alongside the deep nourishment of goat milk and coconut oil. Vitamin E works to repair and protect the skin barrier, while the creamy lather gently lifts away impurities without stripping moisture. Regular use helps even skin tone, reduce dullness, and restore a natural, healthy glow. Free from parabens and harsh chemicals.',
    shelfLife: '6 months from manufacture date',
    weight: '100g (approx) (approx)',
    dimensions: '8cm x 5.4cm x 2.3cm',
    images: [rice1, rice2],
  },
];

export default products;
